import { api } from "./api-core"

export interface IMyLeanbot {
    code: number
    status: string
    data: {
        id: string
        leanbot_id: string
        partner_id: string
        created_at: string
        status: string
        image_url?: string
    }[]
}

export const MyLeanbotApi = {
    getDataMyLeanbots: () => {
        return api
            .get(process.env.API_GET_DATA_LEANBOT as string)
            .then((res) => {
                // Ensure we're returning the full response data with all fields
                return res.data || []
            })
            .catch((err) => {
                console.log(err)
                return []
            })
    },

    validateLeanbotId: (data: {
        leanbot_id: string
    }) => {
        const formData = new FormData()
        // Duyệt qua tất cả các trường và thêm vào formData
        Object.keys(data).forEach((key) => {
            const k = key as keyof typeof data // Ép kiểu key là một khóa hợp lệ của đối tượng data
            if (data[k] !== undefined) {
                if (Array.isArray(data[k])) {
                    // Nếu là mảng, thêm từng phần tử vào formData
                    ; (data[k] as string[]).forEach((item) => {
                        formData.append(`${k}[]`, item)
                    })
                } else {
                    // Nếu là chuỗi hoặc các kiểu đơn giản khác
                    formData.append(k, data[k] as string)
                }
            }
        })

        const url = process.env.URL_VALIDATE_LEANBOT_ID

        return api
            .post(url as string, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            })
            .then((res) => {
                return res.data
            })
    },

    // validateLeanbotId: (id: string) => {
    //     return api
    //         .get(`${process.env.URL_VALIDATE_LEANBOT_ID as string}?id=${id}`)
    //         .then((res) => {
    //             return {
    //                 isValid: res.data.isValid,
    //                 message: res.data.message,
    //             }
    //         })
    //         .catch((err) => {
    //             console.log(err)
    //             throw new Error(err.response?.data?.message || "Failed to validate Leanbot ID")
    //         })
    // },

    registerLeanbot: (data: {
        leanbot_id: string
    }) => {
        const formData = new FormData()
        // Duyệt qua tất cả các trường và thêm vào formData
        Object.keys(data).forEach((key) => {
            const k = key as keyof typeof data // Ép kiểu key là một khóa hợp lệ của đối tượng data
            if (data[k] !== undefined) {
                if (Array.isArray(data[k])) {
                    // Nếu là mảng, thêm từng phần tử vào formData
                    ; (data[k] as string[]).forEach((item) => {
                        formData.append(`${k}[]`, item)
                    })
                } else {
                    // Nếu là chuỗi hoặc các kiểu đơn giản khác
                    formData.append(k, data[k] as string)
                }
            }
        })

        const url = process.env.API_REGISTER_LEANBOT

        return api
            .post(url as string, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            })
            .then((res) => {
                return res.data
            })
    },
    // registerLeanbot: (id: string) => {
    //     return api
    //         .post(process.env.API_REGISTER_LEANBOT as string, { leanbot_id: id })
    //         .then((res) => {
    //             return {
    //                 success: res.data.success,
    //                 message: res.data.message,
    //             }
    //         })
    //         .catch((err) => {
    //             console.log(err)
    //             throw new Error(err.response?.data?.message || "Failed to register Leanbot")
    //         })
    // },

    uploadLeanbotAvatar: (formData: FormData) => {
        const url = process.env.API_UPLOAD_LEANBOT_AVATAR

        return api
            .post(url as string, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            })
            .then((res) => {
                return res.data
            })
            .catch((err) => {
                console.log(err)
                throw new Error(err.response?.data?.message || "Failed to upload Leanbot avatar")
            })
    },
}
